import { render, staticRenderFns } from "./LvUploadImgBtn.vue?vue&type=template&id=645e3522"
import script from "./LvUploadImgBtn.vue?vue&type=script&lang=js"
export * from "./LvUploadImgBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports